import { createContext, useContext, useMemo } from 'react';
import { exceptionTracker, getNormalizedTracker } from 'personalization-lib/utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const UsageTrackerContext = /*#__PURE__*/createContext({
  tracker: exceptionTracker
});
export const UsageTrackerProvider = ({
  children,
  tracker: trackerInstance,
  appName,
  screen
}) => {
  const tracker = useMemo(() => getNormalizedTracker(trackerInstance), [trackerInstance]);
  return /*#__PURE__*/_jsx(UsageTrackerContext.Provider, {
    value: {
      tracker,
      appName,
      screen
    },
    children: children
  });
};
export const useUsageTrackerContext = () => useContext(UsageTrackerContext);